import IncidentListRenderer from '@/components/Incidents/incident-list-renderer';
import { useIncidentsList } from '@/hooks/use-incidents-list';

interface IncidentsListProps {
  selectedRoutes: { journeyId: string; lineNumber: string }[];
  selectedStations: string[];
  activeFilterCount: number;
  onShowFilter: () => void;
}

const IncidentsList = ({
  selectedRoutes,
  selectedStations,
  activeFilterCount,
  onShowFilter,
}: IncidentsListProps) => {
  const { filteredIncidents, isLoading, isEmpty, isError, refetch } = useIncidentsList({
    selectedRoutes,
    selectedStations,
  });

  return (
    <IncidentListRenderer
      data={filteredIncidents}
      isLoading={isLoading}
      isEmpty={isEmpty}
      isError={isError}
      onRetry={refetch}
      activeFilterCount={activeFilterCount}
      onShowFilter={onShowFilter}
    />
  );
};

export default IncidentsList;
